import React from "react";
import styles from "../Boombassador.module.scss";
import loaderBoomer from "../../../images/loader-boomer.png";
import * as Icon from "react-feather";
import { navigate } from "@reach/router";

const AddLogAsBoombassador = ({ student }) => {
  const navigateToSearch = () => {
    navigate("/boombassador");
  };

  return (
    <div className={styles.searchContainer}>
      <div className={`${styles.boombassadorLogo} ${styles.selectedStudent}`}>
        <div className={styles.studentDetails}>
          <span className={styles.loggingFor}>Loggin reading for</span>
          <span
            className={styles.stdName}
          >{`${student.firstName} ${student.lastName}`}</span>
          <span
            className={styles.stdClass}
          >{`Class ${student.classes[0].name}`}</span>
        </div>
        <div>
          <img
            width="90px"
            src={student.boomerAvatarUrl || loaderBoomer}
            alt={loaderBoomer}
          />
        </div>
      </div>
      <div className={`${styles.boombassadorLogo} ${styles.searchBox}`}>
        <Icon.Search
          className={styles.iconDetails}
          onClick={() => navigateToSearch()}
        />
        <span className={styles.fw}>Search new student</span>
      </div>
    </div>
  );
};

export default AddLogAsBoombassador;
